import { useEffect, useState } from "react";
import styled from "styled-components";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Spinner } from "react-bootstrap";
import { useRouter } from "next/router";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useBannerStore } from "@store/useBannerStore";

SwiperCore.use([Navigation, Pagination, Autoplay]);

// ✅ Swiper wrapper
const SwiperWrapper = styled.div`
  width: 100%;
  overflow: visible;

  .swiper-pagination-bullet {
    width: 8px !important;
    height: 8px !important;
    background-color: #ccc;
    margin: 0 4px;
  }

  .swiper-pagination-bullet-active {
    background-color: #1db66d;
  }

  .swiper-pagination-fraction {
    background-color: #000;
    width: fit-content;
    padding: 0px 10px;
    border-radius: 20px;
    right: 8%;
    color: #fff;
    position: absolute;
    bottom: 10px;
    left: auto;
    font-size: calc(10px + (14 - 10) * ((100vw - 320px) / (1920 - 320)));
    z-index: 10;
  }
`;

const SlideCard = styled.div`
  width: 600px;
  flex-shrink: 0;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .slide-img {
    width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 310px;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
    height: auto;

    .slide-img {
      margin-top: 16px;
      padding: 0 16px;
    }
  }
`;

const Intro1 = () => {
  const router = useRouter();
  const { bannerList, mainTop } = useBannerStore((s) => s);
  const hasMainTop = Array.isArray(mainTop) && mainTop.length > 0;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <SwiperWrapper>
      {!hasMainTop ? (
        <></> // 또는 빈 배너 공간, 로딩 스켈레톤 등 처리
      ) : isMobile ? (
        mainTop.length === 1 ? (
          <div
            style={{ padding: "0 16px", maxWidth: "540px", margin: "0 auto" }}
          >
            <a
              href={mainTop[0].link_url || "#"}
              target={mainTop[0].new_win === "Y" ? "_blank" : "_self"}
              rel={
                mainTop[0].new_win === "Y" ? "noopener noreferrer" : undefined
              }
            >
              <figure
                style={{
                  overflow: "hidden",
                  borderRadius: "14px",
                  cursor: "pointer",
                }}
              >
                {mainTop[0].M_FileUrl && (
                  <img
                    src={mainTop[0].M_FileUrl}
                    alt={mainTop[0].img_alt || "모바일 슬라이드"}
                    style={{ width: "100%", display: "block" }}
                  />
                )}
              </figure>
            </a>
          </div>
        ) : (
          <Swiper
            key="mobile"
            spaceBetween={10}
            className="m_swiper"
            pagination={{ type: "fraction" }}
            loop={true}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            loopAdditionalSlides={1}
          >
            {mainTop
              .filter((banner) => banner?.M_FileUrl)
              .map((banner, i) => (
                <SwiperSlide key={i}>
                  <SlideCard>
                    <img
                      src={banner.M_FileUrl}
                      alt={banner.img_alt || "모바일 배너"}
                      className="slide-img"
                      onClick={() => router.push(`${banner.link_url || "#"}`)}
                    />
                  </SlideCard>
                </SwiperSlide>
              ))}
          </Swiper>
        )
      ) : (
        <Swiper
          key="pc"
          slidesPerView={"auto"}
          spaceBetween={12}
          loop={true}
          centeredSlides={true}
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          className="mySwiper"
        >
          {mainTop
            .filter((el) => el?.P_FileUrl)
            .map((el, i) => (
              <SwiperSlide key={i} style={{ width: "600px" }}>
                <SlideCard>
                  <img
                    src={el.P_FileUrl}
                    alt={el.img_alt || "PC 슬라이드"}
                    className="slide-img"
                    onClick={() => {
                      if (el.link_url) router.push(el.link_url);
                    }}
                  />
                </SlideCard>
              </SwiperSlide>
            ))}
        </Swiper>
      )}
    </SwiperWrapper>
  );
};

export default Intro1;
